module.exports = __webpack_public_path__ + "images/fa-oth-xp.webp";